import React, {useEffect, useState} from "react";
import {Nav} from "reactstrap";
import NavbarVerticalMenu from "./navbarVerticalMenu";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores/useStores";
import routes, {IRoute} from "../../routes";
import LogoutButton from "./logoutButton";
import "./navbarVertical.sass";
import {RoutePaths} from "../../shared/routePaths";
import {
  multiVillageKeyValue,
  ProcessedBookingsFeatureName
} from "../../shared/constants";
import {isChrome, isFirefox, isWindows} from "react-device-detect";
import logo from "../../assets/images/myRymanHomeLogo.svg";
import {useVillageFeatureToggle} from "../../utils/featureToggle/villageFeatureToggle";

const NavbarVertical: React.FC = () => {
  const [navRoutes, setNavRoutes] = useState<IRoute[]>(routes);
  const villageFeature = useVillageFeatureToggle(ProcessedBookingsFeatureName);
  const {
    uiStore: {accountStore, selectableVillages}
  } = useStores();

  const HTMLClassList = document.getElementsByTagName("html")[0].classList;

  useEffect(() => {
    if (isWindows) {
      HTMLClassList.add("windows");
    }
    if (isChrome) {
      HTMLClassList.add("chrome");
    }
    if (isFirefox) {
      HTMLClassList.add("firefox");
    }
  }, [HTMLClassList]);

  const getAccessibleRoutes = (routesToFilter: IRoute[]) => {
    return routesToFilter.filter((route) =>
      route.canBeAccessed ? route.canBeAccessed!(accountStore.abilities) : true
    );
  };

  const setRoutes = () => {
    const routesWithAccess = getAccessibleRoutes(routes);
    const filterRoutes = (value: IRoute) => {
      // Hide resident and transactions pages if multi-village is selected
      if (
        (value.to === RoutePaths.ResidentAdmin ||
          value.to === RoutePaths.Transactions) &&
        selectableVillages.selectedItem?.value === multiVillageKeyValue.value
      ) {
        return false;
      }

      // Hide transactions page based on village feature
      if (
        value.to === RoutePaths.Transactions &&
        !villageFeature.hasFeature.value
      ) {
        return false;
      }
      return true;
    };

    setNavRoutes(routesWithAccess.filter(filterRoutes));
  };

  useEffect(() => {
    setRoutes();
  }, [selectableVillages.selectedItem?.value, villageFeature.hasFeature.value]);

  return (
    <div className={"navbar-vertical"}>
      <Nav navbar vertical tag={"div"}>
        <div>
          <img src={logo} alt="Ryman Logo" className="navbar-logo" />
          {accountStore.isAuthenticated && accountStore.isAuthorised && (
            <NavbarVerticalMenu routes={navRoutes} />
          )}
        </div>
        <LogoutButton />
      </Nav>
    </div>
  );
};

export default observer(NavbarVertical);
